export const loadedScriptsOnScroll = 'loadedScriptsOnScroll';

export const recaptchSrc =
  'https://www.google.com/recaptcha/api.js?render=6LfCPMAUAAAAAGPj2JvQRyB45mU8iJabAxT_jLu6';
